import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class CompanyTypePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { companyTypePage,currentCompanyType} = this.props.system;
     this.fetchList( companyTypePage);
  }

  fetchList = (page,values) => {
    const {getCompanyTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getCompanyTypeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { companyTypeById, companyTypeList } = system;
    console.log('companyTypeList====='+companyTypeList);
    if (!companyTypeList) return [];
    return companyTypeList.map(id => companyTypeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getCompanyTypeListPending,companyTypeTotal,companyTypePage } = system
    const { deleteCompanyType,chooseCurrentCompanyType,companyTypeModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getCompanyTypeListPending,
      columns:[
        {
          title: "类别名",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:companyTypeTotal,
        current:companyTypePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentCompanyType(record);
          companyTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteCompanyType(record.id).then((data) => {
            this.fetchList(companyTypePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentCompanyType, companyTypeModalVisible,companyTypePage, companyTypeModalType,submitCompanyTypePending } = system

    const { companyTypeModalChange,submitCompanyType } = actions;
    const editItem  = companyTypeModalType === 'create' ? {} : currentCompanyType
    return {
      item: companyTypeModalType === 'create' ? {} : currentCompanyType,
      visible: companyTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitCompanyTypePending,
      title: `${
        companyTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "name",
          label: "类别名",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitCompanyType(Object.assign({},data,{})).then(data=> {
          companyTypeModalChange(false,"create");
          this.fetchList(companyTypePage);
        })
      },
      onCancel() {
        companyTypeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentCompanyType,companyTypePage} = system
    const { companyTypeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "name",
            widget: Input,
            widgetProps:{
                placeholder:"请输入类别名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        companyTypeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentCompanyType,companyTypePage} = system
    const { companyTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ companyTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyTypePage);


// WEBPACK FOOTER //
// ./src/features/system/CompanyTypePage.js